<div class="stock-performance-box" (click)="showCompanyDetail()" [ngClass]="{first, last}">
  <div class="stock-performance-box-left">
    <div class="logo"><img [src]="item.attributes.image" alt="" /></div>
    <div class="stock-performance-box-detail">
      <div class="ds-ui-2">{{ item.attributes.title }}</div>
      <div>
        <div class="ds-caption-2 ds-color-core-neutral-7">{{item.attributes.position_value.toFixed(0) | thousand:currency }}</div>
      </div>
    </div>
  </div>
  <div class="stock-performance-box-right" *ngIf="item.attributes.performance">
    <app-ds-returns [value]="item.attributes.performance"></app-ds-returns>
  </div>
</div>
